module.exports = __webpack_public_path__ + "static/NU-167a20835012184fcbb3047ed28e46cd.png";